import { ServiceTransport } from '@tencent/s2-client-vue-lib';
import { AppEnum } from '.';

/**
 * 用户信息服务
 * @class ServiceUsers
 * @extends {ServiceTransport}
 */
class ServiceUsers extends ServiceTransport {
	/**
	 * Creates an instance of ServiceUsers.
	 *
	 * @memberOf ServiceUsers
	 */
	constructor() {
		super(AppEnum.DEV_BASE_URL);
	}

	/**
	 * 调用接口示例
	 *
	 * @returns {Promise<any>}
	 * @memberof ServiceUsers
	 */
	public async getTopics(params: any): Promise<any> {
		return await this.get('api/v1/topics', params);
	}

	/** document hooks */
	public async getUsers(params: any): Promise<any> {
		return await this.get('/users', params);
	}

	/** document hooks */
	public async getUserInfo(params: any): Promise<any> {
		return await this.post('/users/info', params);
	}

	/** document hooks */
	public async getUserByName(username: string): Promise<any> {
		return await this.get(`/users/${username}`, {});
	}

	/** document hooks */
	public async updateUser(username: string, data: any): Promise<any> {
		return await this.put(`/users/${username}`, data);
	}

	/** document hooks */
	public async deleteUser(username: string): Promise<any> {
		return await this['delete'](`/users/${username}`, {});
	}

	/** document hooks */
	public async login(data: any): Promise<any> {
		return await this.post('/users/mock-login', data);
	}

	/** document hooks */
	public async logout(): Promise<any> {
		return await this.post('api/v1/topics', {});
	}

	/** document hooks */
	public async register(data: any): Promise<any> {
		return await this.post('api/v1/topics', data);
	}
}

export default new ServiceUsers();
